<template>
    <view-container :headline="'실측기술자 상세'">
        <view-card :headline="'기술자정보'">
            <v-row>
                <v-col>
                    <v-text-field v-for="({ label, vModel, _class }, index) in userInfo.basic" :key="index" :label="label" placeholder=" " hide-details :class="_class" :value="vModel" readonly />
                </v-col>
                <v-col>
                    <view-card-row :mt="false" heading="실측기술자 승인">
                        <v-col cols="12" class="py-0 caption">
                            <v-switch v-model="user.scope" value="measurer" @change="isConsole && saveScope()" color="green" hide-details class="mt-0"></v-switch>
                        </v-col>
                    </view-card-row>
                </v-col>
            </v-row>
        </view-card>
    </view-container>
</template>
<script>
import api from "@/api";
import ViewContainer from "@/components/console/dumb/view-container.vue";
import ViewCard from "@/components/console/dumb/view-card.vue";
import ViewCardColumn from "@/components/console/dumb/view-card-column.vue";
import ViewOverlay from "@/components/console/dumb/view-overlay.vue";
import ViewCardRow from "@/components/console/dumb/view-card-row.vue";
import ViewChips from "@/components/console/dumb/view-chips.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
export default {
    components: {
        ViewContainer,
        ViewCard,
        ViewCardColumn,
        ViewOverlay,
        ViewCardRow,
        ViewChips,
        NaverSmarteditor,
    },
    data() {
        return {
            user: {},
            field_item: ["종합인테리어", "부분인테리어"],
            overlay: {
                show: false,
                src: undefined,
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let _id = this.$route.params._user;
            try {
                const { user } = await api.console.users.getUser({ _id });
                this.user = user;
            } catch (error) {
                console.error(error);
            }
        },

        showOverlay(src) {
            this.overlay = { show: true, src };
        },

        hideOverlay() {
            this.overlay = { show: false, src: undefined };
        },

        async saveScope() {
            try {
                const { _id, scope } = this.user;
                await api.console.users.putUser({ _id, scope });
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isConsole() {
            return this.scope.includes("console");
        },
        userInfo() {
            const _class = "mt-4";
            return {
                basic: [
                    {
                        label: "기술자이름",
                        vModel: this.user?.name || null,
                        _class: "mt-0",
                    },
                    {
                        label: "연락처",
                        vModel: this.user?.phone || null,
                        _class,
                    },
                    {
                        label: "이메일",
                        vModel: this.user?.email || null,
                        _class,
                    },
                ],
            };
        },
    },
};
</script>
